import {
  getAsync, postAsync, sleep,
} from '../apiHelper';
import ChorusInvoiceSubmissionResponse from '../../models/Chorus/ChorusInvoiceSubmissionResponse';
import ChorusInvoiceSubmissionRequest from '../../models/Chorus/ChorusInvoiceSubmissionRequest';
import { getSlug } from '../slugApi';
import {
  getDemoInvoiceList,
  setDemoInvoiceSubmission,
} from '../../store/Demo/DemoInvoiceList';
import getViteBackend from '../../helpers/getViteBackend';
import getViteProxy from '../../helpers/getViteProxy';

const endpoint = `${getViteBackend()}/api/choruspro/invoice-submissions`;
const proxyEndpoint = `${getViteProxy()}/chorus-proxy`;

export async function submitInvoiceToChorusAsync(model: ChorusInvoiceSubmissionRequest): Promise<any> {
  if (getSlug() !== 'demo') {
    const result: any = await postAsync(endpoint, model);
    return result;
  }
  await sleep(300);
  const resp = new ChorusInvoiceSubmissionResponse();
  resp.status = 'ACCEPTED';
  setDemoInvoiceSubmission(
    getDemoInvoiceList.value.findIndex(
      (element) => element.id === model.invoiceId,
    ),
    resp,
  );
  return { invoiceId: '0' };
}

interface IChorusInvoiceStatus {
  statusDate: string;
  statusComment?: string;
  invoiceNumber: string;
  status: string;
  invoiceDate: string;
  id: string;
}

export async function getInvoicesStatusAsync(
  invoiceNumbers: Array<string>,
): Promise<IChorusInvoiceStatus[]> {
  if (invoiceNumbers.length === 0) {
    return [];
  }

  const batchSize = 20;
  const batches = [];
  for (let i = 0; i < invoiceNumbers.length; i += batchSize) {
    batches.push(invoiceNumbers.slice(i, i + batchSize));
  }

  const results = await Promise.all(batches.map(async (batch) => {
    const invoiceNumbersString = batch.join('&invoiceNumbers=');
    const result = await fetch(`${proxyEndpoint}/invoices?invoiceNumbers=${invoiceNumbersString}`, {
      method: 'GET',
      credentials: 'include',
    });

    if (!result.ok) {
      const body: { error: string, status: number, message: string, details?: {
        code?: string,
        errorDescription?: string,
      } } = await result.json();
      throw new Error(body.details?.code || body.message);
    }

    const resultJson: { data: IChorusInvoiceStatus[], total: number, page: number, limit: number, pages: number } = await result.json();

    return resultJson.data;
  }));

  return results.flat();
}

export async function getInvoiceSubmissionStatusAsync(
  pageNb: number,
  invoiceId: string,
): Promise<ChorusInvoiceSubmissionResponse> {
  if (getSlug() !== 'demo') {
    const result: any = await getAsync(
      `${endpoint}?page=${pageNb}&invoiceId=${invoiceId}&order[sendedAt]=desc`,
    );
    if (result['hydra:member'].length) return result['hydra:member'][0] as ChorusInvoiceSubmissionResponse;
    return new ChorusInvoiceSubmissionResponse();
  }
  await sleep(300);
  return new ChorusInvoiceSubmissionResponse();
}
